// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { ChangeEvent, useEffect, useRef, useState, useSyncExternalStore } from "react";
import { List, InputNumber, Card, Button } from "antd";
import { notify } from "@/shared/utils/notify";
import { DeleteOutlined, EyeOutlined } from "@ant-design/icons";
import _ from "lodash";

import { PATH_S3_BUCKET } from "../../../../shared/utils/constants";
import { productMediaService } from "../../../../shared/services";
import { useSelector } from "react-redux";
import { selectProductForUpdate } from "../../../../redux";
import { pendingProductMediaStore } from "../../lib/pendingProductMediaStore";

const { Meta } = Card;

export const useProductsGallery = () => {
  const record = useSelector(selectProductForUpdate);
  const [valueSelect, setValueSelect] = useState("select");
  const [valueTextArea, setValueTextArea] = useState("");
  const [valueNumber, setValueNumber] = useState(0);

  const onChange = (val: string) => {
    setValueSelect(val);
  };

  const onChangeTextArea = (
    val: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setValueTextArea(val.target.value);
  };

  const onChangeNumber = (val: number) => {
    setValueNumber(val);
  };

  const [media, setMedia] = useState<any[]>([]);
  const pendingMedia = useSyncExternalStore(
    pendingProductMediaStore.subscribe,
    pendingProductMediaStore.getAll,
    pendingProductMediaStore.getAll
  );
  const [loading, setLoading] = useState(false);
  const [current_media, setCurrentMedia] = useState<any>();
  const [show, setShow] = useState(false);
  const [type, setType] = useState("image");
  const [urlYouTube, setUrlYouTube] = useState("");
  const flushingRef = useRef(false);
  const flushedForProductRef = useRef<number | null>(null);

  const displayMedia = record?.id ? media : pendingMedia;

  const addPendingMedia = (item: {
    type: string;
    path?: string | null;
    url_youtube?: string | null;
    priority?: number;
  }) => pendingProductMediaStore.add(item);

  const flushPendingMedia = async (productId: number) => {
    const pending = pendingProductMediaStore.getAll();
    if (
      !productId ||
      pending.length === 0 ||
      flushingRef.current ||
      flushedForProductRef.current === productId
    ) {
      return;
    }
    flushingRef.current = true;
    flushedForProductRef.current = productId;
    try {
      await Promise.all(
        pending.map((item, index) =>
          productMediaService.create({
            product_id: productId,
            type: item.type,
            path: item.path || null,
            url_youtube: item.url_youtube || null,
            priority: item.priority ?? index,
          })
        )
      );
      pendingProductMediaStore.clear();
      notify.success(
        pending.length === 1
          ? "Imagen asociada al producto"
          : `${pending.length} imágenes asociadas al producto`
      );
    } catch (err: any) {
      flushedForProductRef.current = null;
      notify.error(err?.message || "Error al asociar las imágenes");
    } finally {
      flushingRef.current = false;
    }
  };

  const UpdateListing = (file: any) => {
    if (!file.key) return;
    if (!record?.id) {
      addPendingMedia({
        type: file.type || "image",
        path: file.key,
        priority: file.index ?? pendingMedia.length,
      });
      return;
    }
    productMediaService
      .create({
        product_id: record.id,
        path: file.key,
        type: file.type,
        priority: file.index,
      })
      .then(() => {
        getMedia();
      })
      .catch((err) => notify.error(err.message));
  };

  const handleSaveEmbed = () => {
    if (!urlYouTube?.trim()) {
      notify.warning("Ingresa un link de YouTube");
      return;
    }
    if (!record?.id) {
      addPendingMedia({
        type: "url_youtube",
        url_youtube: urlYouTube,
        priority: pendingMedia.length,
      });
      setType("image");
      setUrlYouTube("");
      setValueTextArea("");
      notify.success("Video agregado. Se asociará al guardar el producto.");
      return;
    }
    productMediaService
      .create({
        product_id: record.id,
        type,
        url_youtube: urlYouTube,
        priority: 0,
      })
      .then(() => {
        setType("image");
        setUrlYouTube("");
        setValueTextArea("");
        getMedia();
      })
      .catch((err) => notify.error(err.message));
  };

  const getYouTubePreview = (url: string) => {
    try {
      const query = new URLSearchParams(new URL(url).searchParams);
      const vID = query.get("v");
      return `https://img.youtube.com/vi/${vID}/hqdefault.jpg`;
    } catch {
      return "";
    }
  };

  const getYouTubeEmbed = (url: string) => {
    try {
      const query = new URLSearchParams(new URL(url).searchParams);
      const vID = query.get("v");
      return `https://www.youtube.com/embed/${vID}`;
    } catch {
      return "";
    }
  };

  const handleDelete = (id: any) => {
    if (String(id).startsWith("pending-")) {
      pendingProductMediaStore.remove(id);
      notify.info("Imagen eliminada");
      return;
    }
    productMediaService
      .remove(id)
      .then(() => {
        getMedia();
        notify.info("Foto eliminada!");
      })
      .catch((err) => notify.error(err.message));
  };

  const handleShow = (recordItem: any) => {
    setShow(true);
    setCurrentMedia(recordItem);
  };

  const handleOnChange = ({ key, type: mediaType, ...file }: any) => {
    delete file.url;
    let files = media;
    file["uid"] = `${files.length}`;
    file["key"] = key;
    file["type"] = mediaType;
    file["url"] = file.location;
    file["path"] = file.location;
    file["status"] = file.status === 204 ? "done" : "error";
    files.push(file);
    UpdateListing(file);
  };

  const handleposition = (value: any, recordItem: any) => {
    if (recordItem.pending || String(recordItem.id).startsWith("pending-")) {
      pendingProductMediaStore.updatePriority(recordItem.id, value);
      return;
    }
    setMedia([]);
    if (recordItem.id)
      productMediaService
        .patch(recordItem.id, {
          priority: value,
        })
        .then(() => {
          getMedia();
          notify.success("Prioridad Actualizada");
        })
        .catch((err) => notify.error(err.message));
  };

  const getMedia = () => {
    if (!record?.id) return;
    setLoading(true);
    productMediaService
      .find({
        query: {
          product_id: record.id,
          $limit: 999999999,
          $sort: {
            priority: -1,
          },
        },
      })
      .then((res: any) => {
        const data = Array.isArray(res) ? res : res?.data ?? [];
        setMedia(data);
      })
      .catch((err) => {
        notify.error(err?.message || "Error al cargar las imágenes");
        setMedia([]);
      })
      .finally(() => setLoading(false));
  };

  var handleOnposition = _.debounce(handleposition, 1000, { maxWait: 1000 });

  const renderItems = (recordItem: any, index: any) => {
    let url = recordItem.path || recordItem.url;
    if (url && !url.startsWith("http")) url = `${PATH_S3_BUCKET}/${url}`;
    return (
      <List.Item>
        <Card
          actions={[
            <Button
              className="delete"
              shape="circle"
              type="ghost"
              icon={<DeleteOutlined />}
              onClick={() => handleDelete(recordItem.id)}
            />,
            <Button
              className="show"
              shape="circle"
              type="ghost"
              icon={<EyeOutlined />}
              onClick={() => handleShow(recordItem)}
            />,
          ]}
          cover={
            recordItem.type === "url_youtube" ? (
              <img
                width="100%"
                height="100%"
                src={getYouTubePreview(recordItem.url_youtube)}
                alt="media-preview"
              />
            ) : (
              <img
                src={url}
                alt=""
                onError={(e) => {
                  (e.target as HTMLImageElement).src =
                    "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'%3E%3Crect fill='%23f0f0f0' width='100' height='100'/%3E%3Ctext fill='%23999' x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-size='12'%3EError al cargar%3C/text%3E%3C/svg%3E";
                }}
              />
            )
          }
        >
          <Meta
            description={
              <>
                {index === 0 && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      marginBottom: "0px",
                    }}
                  >
                    <span style={{ color: "#fff", margin: 0 }}>
                      Imagen principal
                    </span>
                  </div>
                )}
                <span>Prioridad</span>
                <InputNumber
                  min={0}
                  defaultValue={recordItem.priority}
                  name="priority"
                  onChange={(value) => handleOnposition(value, recordItem)}
                />
              </>
            }
          />
        </Card>
      </List.Item>
    );
  };

  useEffect(() => {
    if (record?.id) getMedia();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record?.id]);

  useEffect(() => {
    if (record?.id && pendingProductMediaStore.getAll().length > 0) {
      flushPendingMedia(record.id).then(() => getMedia());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record?.id]);

  return {
    valueSelect,
    valueTextArea,
    valueNumber,
    onChange,
    onChangeTextArea,
    onChangeNumber,
    current_media,
    setShow,
    show,
    getYouTubeEmbed,
    renderItems,
    loading,
    media: displayMedia,
    pendingMedia,
    addPendingMedia,
    handleSaveEmbed,
    setUrlYouTube,
    setType,
    type,
    handleOnChange,
    getMedia,
  };
};
